import { Icon } from "@/ds";

const AXEN_URL = "https://axen.software";

/**
 * Studio credit.
 *
 * Kept on-system rather than styled as a typical promo strip: mono label,
 * display serif for the studio name, one red signal on the outbound link, and
 * the Button's gap-widening hover instead of an arrow that slides. It reuses
 * the ink tone already established by the skills band, so the page still holds
 * to two background tones total.
 */
export function Footer() {
  return (
    <footer className="bg-surface-ink text-on-ink px-gutter py-7">
      <div className="mx-auto w-full max-w-band flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="flex flex-col gap-3">
          <span className="font-label text-label uppercase text-on-ink-muted">Built under</span>
          <span className="font-display text-[28px] leading-[1.1] text-on-ink">Axen Software</span>
          <p className="text-body-sm text-on-ink-body max-w-[44ch]">
            This portfolio was designed and built by Axen Software, a software studio based in Indonesia.
          </p>
        </div>

        <a
          href={AXEN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 hover:gap-4 self-start md:self-auto border border-border-on-ink rounded-md px-5 py-3 font-label text-label-lg uppercase text-on-ink transition-[background-color,border-color,color,gap] duration-160 ease-out hover:border-signal-500 hover:text-signal-500"
        >
          axen.software
          <Icon name="arrow-right" size={14} />
        </a>
      </div>
    </footer>
  );
}
